module.exports = __webpack_public_path__ + "static/media/211CS151.7dc51ad6.jpeg";